import {ICONS} from "common/helpers";
import "./OpenScheme.scss";

export function OpenScheme({onClick}: {onClick?: (e: any) => void}): JSX.Element | null {
  return <ICONS.HallIcon className="openScheme" onClick={onClick} width="30px" height="30px" style={{cursor: "pointer"}} />;
}
